// extracted by mini-css-extract-plugin
export default {"root":"more_root__2z-Om","content":"more_content__jhYPr","btn":"more_btn__8Eqxb"};